import { setupI18n } from '@lingui/core';
import catalog from '../locale/ru/messages';

const i18n = setupI18n({ language: 'ru', catalogs: { ru: catalog } });

export { i18n };
